import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { ReponseData2 } from '../../../types'
import { RegistrationInspectionScheduleType } from '../../../types/registrationInspectionSchedule'
import { axiosBaseQuery } from '../../baseQuery'

export const registrationInspectionScheduleApi = createApi({
  reducerPath: 'registrationInspectionScheduleApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['RegistrationInspectionSchedule'],
  endpoints: (builder) => ({
    getListRegistrationInspectionSchedule: builder.query({
      query: (params) => ({
        url: NetWork.registrationInspectionSchedule,
        method: GET,
        params: params,
        providesTags: (result: ReponseData2<{ rows: RegistrationInspectionScheduleType[] }>) =>
          result ? [{ type: 'RegistrationInspectionSchedule', id: 'LIST' }] : []
      })
    }),
    getRegistrationInspectionScheduleById: builder.query({
      query: (params: { registrationInspectionScheduleId: number }) => ({
        url: NetWork.registrationInspectionScheduleId(params.registrationInspectionScheduleId),
        method: GET
      })
    }),
    addRegistrationInspectionSchedule: builder.mutation({
      query: (data) => ({
        url: NetWork.registrationInspectionSchedule,
        method: POST,
        data: data
      })
    }),
    updateRegistrationInspectionSchedule: builder.mutation({
      query: (data) => ({
        url: NetWork.registrationInspectionScheduleId(data.id),
        method: PUT,
        data: data
      })
    }),
    deleteRegistrationInspectionSchedule: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.registrationInspectionSchedule,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'RegistrationInspectionSchedule', id: 'LIST' }] // Vô hiệu hóa tag 'RegistrationInspectionSchedule' với id 'LIST' để gọi lại getListRegistrationInspectionSchedule
      })
    }),
    changeStatusRegistrationInspectionSchedule: builder.mutation({
      query: (data: { registrationInspectionScheduleId: number; params: { isActive: boolean } }) => ({
        url: NetWork.registrationInspectionScheduleId(data.registrationInspectionScheduleId),
        method: PATCH,
        params: data.params
      })
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListRegistrationInspectionScheduleQuery,
  useDeleteRegistrationInspectionScheduleMutation,
  useAddRegistrationInspectionScheduleMutation,
  useGetRegistrationInspectionScheduleByIdQuery,
  useUpdateRegistrationInspectionScheduleMutation,
  useChangeStatusRegistrationInspectionScheduleMutation
} = registrationInspectionScheduleApi
